var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 6.6C12.5523 6.6 13 7.04772 13 7.6V11H16.4C16.9523 11 17.4 11.4477 17.4 12C17.4 12.5523 16.9523 13 16.4 13H13V16.4C13 16.9523 12.5523 17.4 12 17.4C11.4477 17.4 11 16.9523 11 16.4V13H7.6C7.04772 13 6.6 12.5523 6.6 12C6.6 11.4477 7.04772 11 7.6 11H11V7.6C11 7.04772 11.4477 6.6 12 6.6Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewCardIcon);
export default __webpack_public_path__ + "static/media/addNewCardIcon.e8810012ad4eb30523e7c5167e38cc9c.svg";
export { ForwardRef as ReactComponent };